import { AlertTriangle } from 'lucide-react'
import { usePageHeader } from '@/components/page-header-context'
import { useDailyStats } from '@/features/dashboard/use-daily-stats'
import { KpiCard } from '@/features/dashboard/kpi-card'
import { formatDt, formatRating } from '@/features/dashboard/format'

export default function DashboardPage() {
  const { data, isLoading, isError } = useDailyStats()
  usePageHeader('Tableau de bord', 'KPI du jour (Africa/Tunis)')

  // `isLoading` n'est vrai qu'au tout premier chargement ; les polls suivants
  // gardent les valeurs précédentes (placeholderData) → pas de retour skeleton.
  const loading = isLoading

  return (
    <div className="flex flex-col gap-3">
      {isError && (
        <div className="flex items-center gap-2 px-4 py-2.5 rounded-[12px] bg-danger/10 border border-danger/30">
          <AlertTriangle size={16} className="text-danger shrink-0" />
          <span className="text-[13px] font-medium text-danger">
            Données indisponibles — nouvelle tentative automatique en cours…
          </span>
        </div>
      )}

      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4">
        <KpiCard
          label="Courses du jour"
          value={String(data?.ridesToday ?? 0)}
          trendPct={data?.ridesTrendPct}
          loading={loading}
        />
        <KpiCard
          label="Chauffeurs actifs"
          value={String(data?.activeDrivers ?? 0)}
          loading={loading}
        />
        <KpiCard
          label="GMV du jour"
          value={formatDt(data?.gmvToday ?? 0)}
          trendPct={data?.gmvTrendPct}
          loading={loading}
        />
        <KpiCard
          label="Note plateforme"
          value={formatRating(data?.platformRating ?? null)}
          loading={loading}
        />
      </div>
    </div>
  )
}
